import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=4dc94b30&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=4dc94b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc94b30",
  null
  
)

export default component.exports